export default "__VITE_ASSET__hWVEPiRg__"